export const homeFilled = {
  name: "home-filled" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12.62 2.248a.9.9 0 0 0-1.24 0l-8.69 8.276C1.448 11.707 2.285 13.8 4 13.8h.6v8.1a.9.9 0 0 0 .9.9h13a.9.9 0 0 0 .9-.9v-8.1h.6c1.715 0 2.552-2.093 1.31-3.276l-8.69-8.276Zm-.69 12.002a.689.689 0 0 0-.68.698v3.104a.69.69 0 0 0 .68.698h2.64a.69.69 0 0 0 .68-.698v-3.104a.689.689 0 0 0-.68-.698h-2.64Z" clip-rule="evenodd"/></svg>`,
  keywords: ["home-filled"],
  category: "buildings" as const,
};
